import styled from "styled-components/macro";
import { useState, useEffect, useCallback } from "react";
import { Slider } from "./Filter.Controls.Interval.Slider";
import { useAfter } from "./Filter.Controls.Interval.after";

export const Interval = ({ active, setFilters, Default, FilterFor, MaxValue, MinValue, PossibleValues, Postfix, Steps }) => {
  const state = active?.interval?.find(i => i.property === FilterFor) ?? null;
  const [value, setValue] = useState(state ? [state.min, state.max] : [MinValue, MaxValue]);

  // Update state when MinValue or MaxValue change
  useEffect(() => {
    const newInitial = state ? [state.min, state.max] : [MinValue, MaxValue];
    setValue(newInitial);
  }, [active?.interval, FilterFor, MinValue, MaxValue]);

  const change = useCallback((e) => setValue(e), []);
  const after = useAfter({ active, setFilters, Default, FilterFor });

  return (
    <Box>
      <Slider
        dv={[MinValue, MaxValue]}
        pf={Postfix}
        pv={PossibleValues}
        value={value}
        step={Steps}
        max={MaxValue}
        min={MinValue}
        change={change}
        after={after}
        name={FilterFor}
      />
    </Box>
  );
};

const Box = styled.div`
  width: 100%;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;
